import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api
      .post("/auth/session", { session_id: sessionId })
      .then(({ data }) => navigate(data.is_admin ? "/admin" : "/admin/login", { replace: true, state: { user: data } }))
      .catch(() => navigate("/admin/login", { replace: true, state: { error: true } }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <div className="min-h-screen bg-ink" data-testid="auth-callback" />;
}
